import { VisaPathway } from "../VisaPathwaySelection";
import { Card } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";

interface SummaryProps {
  data: any;
  visaPathway: VisaPathway;
}

const Summary = ({ data, visaPathway }: SummaryProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold mb-2">Review Your Information</h2>
        <p className="text-muted-foreground">
          Please review your information before submitting the assessment.
        </p>
      </div>

      <Card className="p-6 bg-accent/5">
        <h3 className="text-lg font-semibold mb-4">Selected Visa Pathway</h3>
        <div className="space-y-2">
          <p className="text-lg font-medium">{visaPathway.title}</p>
          <p className="text-muted-foreground">{visaPathway.description}</p>
        </div>
      </Card>

      <div className="grid gap-6">
        {/* Personal Information */}
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Personal Information</h3>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Name: {data.personalInfo.fullName}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Email: {data.personalInfo.email}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Phone: {data.personalInfo.phone}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Target Roles: {data.personalInfo.targetRoles}</span>
            </div>
          </div>
        </Card>

        {/* Professional Qualifications */}
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Professional Qualifications</h3>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Qualifying Profession: {data.qualifications.qualifyingProfession}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Tech Activity (Past 5 Years): {data.qualifications.techActivityPast5Years ? "Yes" : "No"}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Leadership Experience: {data.qualifications.leadershipExperience}</span>
            </div>
          </div>
        </Card>

        {/* Experience */}
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Experience</h3>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Technology Experience: {data.experience.technologyExperience}</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Non-Qualifying Profession: {data.experience.nonQualifyingProfession}</span>
            </div>
          </div>
        </Card>

        {/* Recognition */}
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Recognition & Awards</h3>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-primary" />
              <span>Excellence Awards: {data.recognition.excellenceAwards}</span>
            </div>
            {data.recognition.awardRecognition && (
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-primary" />
                <span>Award Recognition Level: {data.recognition.awardRecognition}</span>
              </div>
            )}
          </div>
        </Card>
      </div>

      <div className="bg-accent/5 p-4 rounded-lg">
        <p className="text-sm text-muted-foreground">
          By submitting this assessment, you confirm that all provided information is accurate and complete.
          The assessment results will be based on the information you have provided.
        </p>
      </div>
    </div>
  );
};

export default Summary;